import { customGet, customPost } from "../../../api/customApi";
import entityType from "../../../api/entityType";
import genericActionType from "../../../api/genericActionType";
import Actions from "./userConstants";
import {values} from "lodash";

const errorPayload = (message = "Something went wrong.", data = null) => {
  return {
    Data: data,
    Operation: { Outcome: "Error", Message: message },
  };
};

export const loadSettingsStatus = () => async (dispatch) => {
  dispatch({ type: Actions.SETTINGS_LOAD_STATUS });
  try {
    const result = await customGet(
      entityType.MULTI_FACTOR_AUTHENTICATION,
      "Status",
      { identity: true, shouldThrow: true }
    );

    dispatch({
      type: Actions.SETTINGS_LOAD_STATUS_SUCCEEDED,
      payload: result,
    });
  } catch (e) {
    dispatch({
      type: Actions.SETTINGS_LOAD_STATUS_SUCCEEDED,
      payload: errorPayload(),
    });
  }
};

export const setPreferredMfa = (Provider) => async (dispatch) => {
  dispatch({ type: Actions.SETTINGS_SET_PREFERRED_MFA });
  try {
    const result = await customPost(
      entityType.MULTI_FACTOR_AUTHENTICATION,
      "SetPreferred",
      { Provider },
      { identity: true, shouldThrow: true }
    );

    dispatch({
      type: Actions.SETTINGS_SET_PREFERRED_MFA_SUCCEEDED,
      payload: result,
    });
  } catch (e) {
    dispatch({
      type: Actions.SETTINGS_SET_PREFERRED_MFA_SUCCEEDED,
      payload: errorPayload("Could not update preferred MFA.", false),
    });
  }
};

export const setPhoneNumber = (PhoneNumber) => async (dispatch) => {
  dispatch({ type: Actions.SETTINGS_SET_PHONE_NUMBER });
  try {
    const result = await customPost(
      entityType.MULTI_FACTOR_AUTHENTICATION,
      "SetPhoneNumber",
      { PhoneNumber },
      { identity: true, shouldThrow: true }
    );

    dispatch({
      type: Actions.SETTINGS_SET_PHONE_NUMBER_SUCCEEDED,
      payload: result,
    });
  } catch (e) {
    dispatch({
      type: Actions.SETTINGS_SET_PHONE_NUMBER_SUCCEEDED,
      payload: errorPayload("Could not update phone number.", false),
    });
  }
};

export const verifyAuthenticator =
  ({ Code }) =>
  async (dispatch) => {
    dispatch({ type: Actions.SETTINGS_VERIFY_AUTHENTICATOR });
    try {
      const result = await customPost(
        entityType.MULTI_FACTOR_AUTHENTICATION,
        "Verify",
        { Code },
        { identity: true, shouldThrow: true }
      );

      dispatch({
        type: Actions.SETTINGS_VERIFY_AUTHENTICATOR_SUCCEEDED,
        payload: result,
      });
    } catch (e) {
      dispatch({
        type: Actions.SETTINGS_VERIFY_AUTHENTICATOR_SUCCEEDED,
        payload: errorPayload(),
      });
    }
  };

export const resetAuthenticator = () => async (dispatch) => {
  dispatch({ type: Actions.SETTINGS_RESET_AUTHENTICATOR });
  try {
    const result = await customGet(
      entityType.MULTI_FACTOR_AUTHENTICATION,
      "ResetAuthenticator",
      { identity: true, shouldThrow: true }
    );

    dispatch({
      type: Actions.SETTINGS_RESET_AUTHENTICATOR_SUCCEEDED,
      payload: result,
    });
  } catch (e) {
    dispatch({
      type: Actions.SETTINGS_RESET_AUTHENTICATOR_SUCCEEDED,
      payload: errorPayload(),
    });
  }
};

export const getAuthQrBase64 = () => async (dispatch) => {
  dispatch({ type: Actions.SETTINGS_GET_AUTH_QR_START });
  try {
    const result = await customGet(
      entityType.MULTI_FACTOR_AUTHENTICATION,
      "QrBase64",
      { identity: true, shouldThrow: true }
    );

    dispatch({
      type: Actions.SETTINGS_GET_AUTH_QR_SUCCESS,
      payload: result,
    });
  } catch (e) {
    dispatch({
      type: Actions.SETTINGS_GET_AUTH_QR_SUCCESS,
      payload: errorPayload("Failed to load QR."),
    });
  }
};

export const clearSettingsResult = () => async (dispatch) => {
  dispatch({ type: Actions.SETTINGS_CLEAR_RESULT });
};

export const listUsersAction = (agencyKeys) => async (dispatch) => {
  dispatch({ type: Actions.LIST_USERS });
  let transformedValues = agencyKeys;
  if (agencyKeys == [0]) {
    const state = getState();
    const agencies = state.agency.listCompact;
    const allAgencies = !agencies ? [] : agencies.map((a) => a.Id);
    transformedValues = allAgencies;
  }
  const payload = await customPost(entityType.USER, "List", transformedValues);
  dispatch({ type: Actions.LIST_USERS_SUCCEEDED, payload });
};


export const createUserAction = (values) => async (dispatch) => {
  dispatch({ type: Actions.CREATE_USER });
  const payload = await customPost(entityType.USER, "Create", values);
  dispatch({ type: Actions.CREATE_USER_SUCCEEDED, payload });
};

export const resendEmailConfirmationAction = (userId) => async (dispatch) => {
  dispatch({ type: Actions.RESEND_EMAIL_CONFIRMATION });
  let data = {
    UserId: userId,
  };
  const payload = await customPost(
    entityType.IDENTITY,
    "ResendEmailConfirmation",
    data,
    { identity: true }
  );
  dispatch({ type: Actions.RESEND_EMAIL_CONFIRMATION_SUCCEEDED, payload });
};

export const updateUserAction = (values) => async (dispatch) => {
  dispatch({ type: Actions.UPDATE_USER });
  const payload = await customPost(entityType.USER, "Update", values);
  dispatch({ type: Actions.UPDATE_USER_SUCCEEDED, payload });
};

export const readUserAction = (userKey) => async (dispatch) => {
  dispatch({ type: Actions.READ_USER });
  const payload = await customGet(entityType.USER, genericActionType.READ, {
    params: {
      userKey: userKey,
    },
  });
  dispatch({ type: Actions.READ_USER_SUCCEEDED, payload });
};

export const unlockUserAccount = (id4UserId) => async (dispatch) => {
  dispatch({ type: Actions.UNLOCK_USER });
  const payload = await customGet(entityType.USER, "UnlockAccount", {
    params: {
      id4UserId: id4UserId,
    },
  });
  dispatch({ type: Actions.UNLOCK_USER_SUCCEEDED, payload });
};

export const deleteUser = (model) => async (dispatch) => {
  dispatch({ type: Actions.DELETE_USER });
  const payload = await customPost(entityType.USER, "Delete", model);
  dispatch({ type: Actions.DELETE_USER_SUCCEEDED, payload });
};

export const bulkDeleteUsers = (model) => async (dispatch) => {
  dispatch({ type: Actions.BULK_DELETE_USERS });
  const payload = await customPost(entityType.USER, "BulkDelete", model);
  dispatch({ type: Actions.BULK_DELETE_USERS_SUCCEEDED, payload });
};

export const toggleUserEnabledAction = (id4UserId) => async (dispatch) => {
  dispatch({ type: Actions.TOGGLE_USER_ENABLED });
  const payload = await customGet(entityType.USER, "ToggleEnabled", {
    params: {
      id4UserId: id4UserId,
    },
  });
  dispatch({ type: Actions.TOGGLE_USER_ENABLED_SUCCEEDED, payload });
};

export const clearDeleteOperationResultsAction = () => async (dispatch) => {
  dispatch({ type: Actions.CLEAR_DELETE_OPERATION_RESULTS });
};

export const clearBulkDeleteOperationResults = () => async (dispatch) => {
  dispatch({ type: Actions.CLEAR_BULK_DELETE_OPERATION_RESULT });
};

export const clearIdentityOperationResult = () => async (dispatch) => {
  dispatch({ type: Actions.CLEAR_IDENTITY_OPERATION_RESULT });
};

export const clearSelectedUserAction = () => async (dispatch) => {
  dispatch({ type: Actions.CLEAR_SELECTED_USER });
};

export const clearOperationResultAction = () => async (dispatch) => {
  dispatch({ type: Actions.CLEAR_OPERATION_RESULT });
};

export const clearLegacyOperationResultAction = () => async (dispatch) => {
  dispatch({ type: Actions.CLEAR_LEGACY_OPERATION_RESULT });
};

export const changePassword = (model) => async (dispatch) => {
  dispatch({ type: Actions.CHANGE_PASSWORD });
  const payload = await customPost(entityType.USER, "ChangePassword", model);
  dispatch({ type: Actions.CHANGE_PASSWORD_SUCCEEDED, payload });
};

export const setSelectedUserRows = (values) => async (dispatch) => {
  dispatch({
    type: Actions.SET_SELECTED_USER_ROWS,
    payload: { selectedRows: values },
  });
};

export const clearSelectedUserRows = () => async (dispatch) => {
  dispatch({
    type: Actions.CLEAR_SELECTED_USER_ROWS,
  });
};
